import * as Sentry from '@sentry/browser';

import { Middleware } from '@neptune/shared/core-apis-middleware-domain';

// Our current openapi-generator version throws errors as ResponseError, whose shape isn't handled properly by FE app. This middleware throws the response object instead as a workaround.
export const responseErrorMiddleware: Middleware = {
  async post({ response }) {
    if (response) {
      if (response.status >= 200 && response.status < 300) {
        return response;
      }

      if (response.status === 401 || response.status === 403) {
        Sentry.addBreadcrumb({
          category: 'authentication',
          message: 'Unauthorized or Forbidden',
          level: 'info',
          data: {
            url: response.url,
            status: response.status,
          },
        });
      }
    }

    throw response;
  },
};
